import { t } from 'i18next';
import { useCallback, useState } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useInput } from '../../../hooks';
import { useAccountLoginMutation, useLoginMutation } from '../../../services/api';
import { useAlert } from '../../alert';
import { extractErrorDetail } from '../../common';
import Button from '../Button/Button';
import Form from '../Form';
import { TotpModal } from '../Home/HomeAuth';
import { Modal } from '../Modal';
import PasswordInput from '../PasswordInput';
import { EmailValidationModal } from './EmailValidationModal';
import { ForgotPasswordModal } from './ForgotPasswordModal';
import { ModalProps } from './types';


export function useLogin() {
    const alert = useAlert();
    const navigate = useNavigate();

    const [login] = useLoginMutation();
    const [accountLogin] = useAccountLoginMutation();

    return useCallback((username: string, password: string, token?: string, onTOTP?: () => void, onSuccess?: () => void, onError?: (e: string) => void) => {
        login({ username: username, password: password, token }).unwrap().then((data) => {
            if (!localStorage.authorized) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                // (window as any).ym(99048680, 'init', {
                //     defer: true,
                //     clickmap: true,
                //     trackLinks: true,
                //     accurateTrackBounce: true
                // });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (window as any).yaCounter100032604.destruct();
            }
            localStorage.authorized = true;
            if (!data.pd_agreement) {
                window.location.pathname !== '/agreement' && navigate('/agreement');
                return;
            }
            const jwt = data.access.split('.')[1];
            const jwtDecoded = JSON.parse(atob(jwt));
            if (jwtDecoded.accound_id) {
                onSuccess && onSuccess();
                window.location.pathname === '/login' && navigate('/');
                return;
            }
            if (data.accounts?.length === 1 || data.accounts?.length === 2) {
                accountLogin({
                    refresh: data.refresh,
                    username: username,
                    account: data.accounts?.at(data.accounts.length - 1)?.id.toString() || ''
                }).unwrap().then((z) => {
                    if (!z.agr_offer) {
                        window.location.pathname !== '/agreement' && navigate('/agreement');
                        return;
                    }
                    onSuccess && onSuccess();
                    window.location.pathname === '/login' && navigate('/');
                }).catch((e) => {
                    if (e.status === 418) {
                        console.log('TOTP')
                        onTOTP && onTOTP();
                    } else {
                        onError ? onError(extractErrorDetail(e)) : alert.error(extractErrorDetail(e));
                    }
                });
            } else {
                onSuccess && onSuccess();
                window.location.pathname === '/login' && navigate('/');
            }
        }).catch((e) => {
            if (e) {
                if (e.status === 423) {
                    const reason = e.data?.response?.status?.detail;
                    onError ? onError(extractErrorDetail(e)) : alert.error(`Уважаемый пользователь! Доступ к сайту временно приостановлен.\n ${reason ? 'Причина: ' + reason : ''}.`);
                } else if (e.status === 418) {
                    onTOTP && onTOTP();
                } else {
                    const detail = e.data?.detail;
                    if (detail) {
                        onError ? onError(extractErrorDetail(e)) : alert.error(t(detail));
                    } else {
                        onError ? onError(extractErrorDetail(e)) : alert.error(t(extractErrorDetail(e)));
                    }
                }
            } else {
                onError ? onError(extractErrorDetail(e)) : alert.error(t(e.message));
            }
        });
    }, []);
}

function LoginModalContent({ onClose }: Omit<ModalProps, 'isOpen'>) {
    // const alert = useAlert();
    const navigate = useNavigate();
    const login = useLogin();

    // const [login, { isLoading }] = useLoginMutation();
    // const [accountLogin] = useAccountLoginMutation();
    const [empty, setEmpty] = useState<boolean>();
    const emptyUsername = t('Enter Email');
    const emptyPassword = t('Enter password');

    const [username, resetUsername] = useInput('');
    const [password, resetPassword] = useInput('');
    const [error, setError] = useState('');
    const [showTotp, setShowTotp] = useState(false);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showForgot, setShowForgot] = useState(false);

    function resetForm() {
        resetUsername();
        resetPassword();
    }

    function onLogin() {
        setError('');
        let isEmpty = false;
        if (!username.value) {
            isEmpty = true;
        }
        if (!password.value) {
            isEmpty = true;
        }
        setEmpty(isEmpty);
        if (isEmpty) {
            return;
        }
        login(username.value, password.value, undefined, () => setShowTotp(true), () => {
            onClose();
            resetForm();
            if (window.location.pathname.startsWith('/public-') && !window.location.pathname.startsWith('/public-showcase')) {
                navigate(`/${window.location.pathname.slice(8)}`);
            }
        });

        // login({ username: username.value, password: password.value }).unwrap().then((data) => {
        //     if (!localStorage.authorized) {
        //         // eslint-disable-next-line @typescript-eslint/no-explicit-any
        //         (window as any).ym(99048680, 'init', {
        //             defer: true,
        //             clickmap: true,
        //             trackLinks: true,
        //             accurateTrackBounce: true
        //         });
        //         // eslint-disable-next-line @typescript-eslint/no-explicit-any
        //         (window as any).yaCounter100032604.destruct();
        //     }
        //     localStorage.authorized = true;
        //     if (!data.pd_agreement) {
        //         window.location.pathname !== '/agreement' && navigate('/agreement');
        //         return;
        //     }
        //     const jwt = data.access.split('.')[1];
        //     const jwtDecoded = JSON.parse(atob(jwt));
        //     if (jwtDecoded.accound_id) {
        //         resetForm();
        //         // window.location.reload();
        //         window.location.pathname === '/login' && navigate('/');
        //         return;
        //     }
        //     onClose();
        //     if (data.accounts?.length === 1 || data.accounts?.length === 2) {
        //         accountLogin({
        //             refresh: data.refresh,
        //             username: username.value,
        //             account: data.accounts?.at(data.accounts.length - 1)?.id.toString() || ''
        //         }).unwrap().then((z) => {
        //             if (!z.agr_offer) {
        //                 window.location.pathname !== '/agreement' && navigate('/agreement');
        //                 return;
        //             }
        //             resetForm();
        //             // window.location.reload();
        //             window.location.pathname === '/login' && navigate('/');
        //         }).catch((e) => {
        //             if (e.status === 418) {
        //                 console.log(e);
        //             } else {
        //                 alert.error(extractErrorDetail(e));
        //             }
        //             setError(e.message);
        //         });
        //     } else {
        //         resetForm();
        //         // window.location.reload();
        //         window.location.pathname === '/login' && navigate('/');
        //     }
        // }).catch((e) => {
        //     if (e) {
        //         if (e.status === 423) {
        //             const reason = e.data?.response?.status?.detail;
        //             setModalErrorText(`Уважаемый пользователь! Доступ к сайту временно приостановлен.\n ${reason ? 'Причина: ' + reason : ''}.`);
        //             setShowError(true);
        //         } else if (e.status === 418) {
        //             setShowTotp(true);
        //         } else {
        //             const detail = e.data?.detail;
        //             if (detail) {
        //                 setError(t(detail));
        //             } else {
        //                 setError(t(extractErrorDetail(e)));
        //             }
        //         }
        //     } else {
        //         setError(t(e.message));
        //     }
        // });
    }

    return (
        <Form className="form-login">
            <EmailValidationModal isOpen={showRegistration} onClose={() => setShowRegistration(false)} />
            <ForgotPasswordModal isOpen={showForgot} onClose={() => setShowForgot(false)} />
            <TotpModal user={username.value} password={password.value} isOpen={showTotp} onClose={() => setShowTotp(false)} onSuccess={() => onClose()} />
            <h2 className="popup__heading">
                <Trans>Log In</Trans>
            </h2>

            <div className={'form__item' + ((error || (empty && !username.value)) ? ' _error' : '')}>
                <input {...username} name="username" className={'form__input _required' + ((error || (empty && !username.value)) ? ' _error' : '')} required placeholder={t('Enter Email')} />
                {(empty && !username.value) && <div className="form__input-error-message">{emptyUsername}</div>}
                {error && <div className="form__input-error-message">{error}</div>}
            </div>
            <div
                className={'form__item' + ((error || (empty && !password.value)) ? ' _error' : '')}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onLogin();
                    }
                }}>
                <PasswordInput {...password} name="password" className={'_required' + ((error || (empty && !password.value)) ? ' _error' : '')} required placeholder={t('Enter password')} />
                {(empty && !password.value) && <div className="form__input-error-message">{emptyPassword}</div>}
            </div>

            <div className="form__submit">
                <Button
                    // disabled={isLoading}
                    onClick={onLogin}
                >
                    <Trans>Sign in</Trans>
                </Button>
            </div>

            <div className="form__link-btn" onClick={() => setShowForgot(true)}>
                <div className="link link-accent">
                    <Trans>Recover password</Trans>?
                </div>
            </div>
            <div className="form__link-btn">
                <div className="link link-accent" onClick={() => setShowRegistration(true)}>
                    <Trans>Register</Trans>
                </div>
            </div>
        </Form>
    );
}

export function LoginModal({ isOpen, onClose }: ModalProps) {
    return (
        <Modal className={'popup_feedback'} isOpen={isOpen} onClose={onClose}>
            <LoginModalContent onClose={onClose} />
        </Modal>
    );
}
